<template>
  <div class="impressumPage">
    <div class="section section-about-us first-section">
      <div class="container">
        <div class="row">
          <div class="col-md-12 ml-auto mr-auto text-center">
            <h2 class="title">Stellenangebote</h2>
          </div>
        </div>
        <div class="separator separator-primary"></div>
        <div class="section-story-overview">
          <div class="row">
            <div class="col-md-12">
              <!-- Kunststofftechniker Stellenanzeige -->
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title"><b>Kunststofftechniker*in (m/w/d)</b></h4>
                  <p class="card-text">
                    Seit 1991 fertigen wir in Unteruhldingen hochwertigen Zahnersatz für unsere anspruchsvollen
                    Zahnärzte.
                    Zum nächstmöglichen Termin suchen wir, ein*e Vollzeit- oder Teilzeitmitarbeiter*in, für die
                    Kunststofftechnik im Dentallabor.<br />
                    <br />
                    <b>Dein Aufgabengebiet:</b>
                  <ul class="sublist">
                    <li>Total- /Teilprothesen</li>
                    <li>Interimsprothesen</li>
                    <li>Schienentechnik</li>
                    <li>Prothesen-Reparaturen</li>
                  </ul>
                  <b>Das bringst du mit:</b>
                  <ul class="sublist">
                    <li>abgeschlossene Zahntechnikausbildung oder Quereinsteiger mit 3 Jahren Berufserfahrung</li>
                    <li>Freude am exakten Arbeiten</li>
                    <li>Organisationstalent</li>
                  </ul>
                  Fragen? Dann ruf uns gerne an!<br />
                  <br />
                  Wir freuen uns auf Deine Bewerbung!<br />
                  Gernot Goetz und das Team der Zahnwerkstatt<br />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ZahnwerkstattJobsPage",
};
</script>

<style scoped></style>
